"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function stableSort(array, cmp) {
    var stabilizedThis = array.map(function (el, index) { return [el, index]; });
    stabilizedThis.sort(function (a, b) {
        var order = cmp(a[0], b[0]);
        if (order !== 0)
            return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map(function (el) { return el[0]; });
}
exports.default = stableSort;
//# sourceMappingURL=stableSort.js.map